import React from 'react';
import {connect} from 'react-redux';

import {Dispatch} from 'spectra-logic-ui';
import {FormDialog, SingleSelect} from 'spectra-logic-ui/components';
import {updateResource} from 'spectra-logic-ui/actions';

import {Destination} from '@/types';
import {Object} from '@/buckets/objects/types';
import validate from '@/buckets/objects/details/validate';

type Props = {
  bucketName: string;
  object: Object;
  destinations: Destination[];
  onSubmit: (values: any) => Promise<any>;
}

export type FormData = {
  storage: string;
}

const AddStorageDialog = ({destinations, ...others}: Props) => {
  const {...formProps}: any = others;
  delete formProps.bucketName;
  delete formProps.object;

  const options = destinations.map((destination) => (
    {key: destination.id, text: destination.name + ' (' + destination.id + ')'}
  ));

  return (
    <FormDialog title='Add Storage' validate={validate} {...formProps}>
      {() => (
        <SingleSelect name='storage' label='Select Storage' options={options} />
      )}
    </FormDialog>
  );
};

const mapDispatchToProps = (dispatch: Dispatch, {bucketName, object}: Props) => {
  const query = {
    version: object.versionId !== undefined ? object.versionId : '',
  };
  return {
    onSubmit: (values: FormData) => dispatch(updateResource(
      `buckets/${bucketName}/storage/objects/${values.storage}`,
      object.key, {}, {query: query})),
  };
};

export default connect(undefined, mapDispatchToProps)(AddStorageDialog);
